import { hashString } from './hash';

export class MemoryCache<T> {
  private readonly cache = new Map<string, T>();

  private createKey(id: string, name: string, content: unknown): string {
    return `${id}:${name}:${hashString(JSON.stringify(content))}`;
  }

  getOrCreate<TContent>(options: {
    id: string;
    name: string;
    content: TContent;
    factory: (content: TContent) => T;
  }): T {
    const { id, name, content, factory } = options;
    const key = this.createKey(id, name, content);

    let value = this.cache.get(key);
    if (!value) {
      value = factory(content);
      this.cache.set(key, value);
    }

    return value;
  }

  clear(): void {
    this.cache.clear();
  }

  size(): number {
    return this.cache.size;
  }
}
